import React, { useEffect, useState } from 'react';
import CourseStructureTree from './CourseStructureTree';

export default function CoursePage() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/course/get-course-structure-with-content?courseId=CR0002&parentLevelId=1766`) // Update to your actual API URL
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to fetch course structure');
        }
        return response.json();
      })
      .then((data) => {
        setData(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error:', err);
        setError(err.message);
        setLoading(false);
      });
  }, []);

  if (loading) return <div className="p-4">Loading course structure...</div>;
  if (error) return <div className="p-4 text-red-600">Error: {error}</div>;

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Course Structure</h1>
      <CourseStructureTree data={data} />
    </div>
  );
}
